import { createAction } from '@reduxjs/toolkit';
import type { BoundaryGroupId } from '~/store/boundaries/boundaryIdentifier.type';
import type {
  DataLayer, DataLayerData, DataLayerId,
} from './mapSettingsDataLayers.state';

export const mapSettingsDataLayersAddDataLayer = createAction(
  'MAP_SETTINGS_DATA_LAYERS_ADD_DATA_LAYER',
  (dataLayer: DataLayer) => ({
    payload: { dataLayer },
  })
);

export const mapSettingsDataLayersRemoveDataLayer = createAction(
  'MAP_SETTINGS_DATA_LAYERS_REMOVE_DATA_LAYER',
  (dataLayer: DataLayer) => ({
    payload: { dataLayer },
  })
);

export const mapSettingsDataLayersUpdateDataLayer = createAction(
  'MAP_SETTINGS_DATA_LAYERS_UPDATE_DATA_LAYER',
  (id: DataLayerId, data: DataLayerData) => ({
    payload: { id, data },
  })
);

export const mapSettingsDataLayersUpdateBoundaryGroup = createAction(
  'MAP_SETTINGS_DATA_LAYERS_UPDATE_BOUNDARY_GROUP',
  (dataLayerId: DataLayerId, boundaryGroupId: BoundaryGroupId) => ({
    payload: { dataLayerId, boundaryGroupId },
  })
);
